export enum ReturnPopinTypesEnum {
  NULL,
  INFO,
  SUCCESS,
  WARNING,
  ERROR,
}
